import { render, staticRenderFns } from "./DoctorPreview.vue?vue&type=template&id=55ffe044&scoped=true"
import script from "./DoctorPreview.vue?vue&type=script&lang=js"
export * from "./DoctorPreview.vue?vue&type=script&lang=js"
import style0 from "./DoctorPreview.vue?vue&type=style&index=0&id=55ffe044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ffe044",
  null
  
)

export default component.exports